import { Stack, styled } from '@zenchef/styled-system/jsx'

const TableRowBox = styled(Stack, {
  base: {
    padding: 'padding.3',
    color: 'content.neutral.base.bold',
    _first: {
      borderTopRadius: 'l'
    },
    _last: {
      borderBottom: 'none',
      borderBottomRadius: 'l'
    },
    borderWidth: 'm',
    borderBottomStyle: 'solid',
    borderColor: 'border.neutral.subtle'
  }
})

export default TableRowBox
